import type { MenuItem } from 'primereact/menuitem'
import { TieredMenu as PrimeReactMenu } from 'primereact/tieredmenu'
import type { Ref } from 'react'
import './menu.css'

interface MenuProps {
  items: Array<MenuItem>
  ref?: Ref<PrimeReactMenu>
}

function Menu({ items, ref }: MenuProps) {
  return <PrimeReactMenu ref={ref} model={items} popup></PrimeReactMenu>
}

export default Menu
